import { ContractDetail, ServiceContract } from 'src/common/models/contract'
import * as Styles from './styles'
import { formatToCurrency } from 'src/common/util'
import { useState } from 'react'
import { DeleteOutlined, PercentageOutlined, UnorderedListOutlined, DownOutlined, UpOutlined, FormOutlined } from '@ant-design/icons'
import { Button, CollapseProps } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'src/state/reducer'
import { updateCurrentContract } from 'src/features/ServiceContract/state/action'
import { CharacteristicsModal } from './CharacteristicsModal'
import { ItemData } from './ItemData'
import { PriceModal } from './PriceModal'
import { SystemDescriptions } from 'src/common/descriptions'
import { DescriptionModal } from './DescriptionModal'

export type ReduxProps = {
    currentContract?: Partial<ServiceContract>
}

interface Props {
    itemDetail: ContractDetail
    isEmbed?: boolean
}

export const ItemCard = (props: Props) => {
    const dispatch = useDispatch()

    const [isCollapsed, setIsCollapsed] = useState<boolean>(props.isEmbed ? false : true)
    const [modalCharOpen, setModalCharOpen] = useState<boolean>(false)
    const [modalPriceOpen, setModalPriceOpen] = useState<boolean>(false)
    const [modalDescriptionOpen, setModalDescriptionOpen] = useState<boolean>(false)

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        currentContract: state.serviceContract.currentContract,
    }))

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT

    const renderActionsSection = () => (
        <Styles.ActionsContainer>
            {
                !props.isEmbed &&
                <Button
                    size='small'
                    shape="circle"
                    icon={isCollapsed ? <DownOutlined /> : <UpOutlined />}
                    onClick={handleCardClick}
                />
            }
            <Styles.ItemPrice>Q {formatToCurrency(props.itemDetail.price.toString())}</Styles.ItemPrice>
        </Styles.ActionsContainer>
    )

    const handleCardClick = () => {
        setIsCollapsed(!isCollapsed)
    }

    const handleRemoveItem = () => {
        const newDetail: ContractDetail[] = []
        let total: number = 0

        reduxProps.currentContract?.detail?.forEach(item => {
            if (item.ref !== props.itemDetail.ref) {
                total += item.price
                newDetail.push(item)
            }
        })

        dispatch(updateCurrentContract({
            total,
            detail: newDetail,
        }))
    }

    const items: CollapseProps['items'] = [
        {
            key: 'CHARACTERISTICS',
            label: descriptions.CHARACTERISTICS.LABEL,
            children: <ul style={{ fontSize: 12, paddingLeft: 12, }} >{props.itemDetail.characteristics.map(item => <li key={item} >{item}</li>)}</ul>,
        },
    ];

    const handleCharacteristicsClick = () => {
        setModalCharOpen(true)
    }

    const handlePriceClick = () => {
        setModalPriceOpen(true)
    }

    const handleDescriptionClick = () => {
        setModalDescriptionOpen(true)
    }

    const renderCollapsibleSection = () => (
        !isCollapsed &&
        <Styles.BottomContainer>
            <Styles.SectionContainer side='LEFT' >
                <>
                    <Styles.CharCollapse defaultActiveKey={[]} ghost items={items} style={{ width: '100%' }} />
                </>
            </Styles.SectionContainer>
            {
                !props.isEmbed &&
                <Styles.SectionContainer side='RIGHT'>
                    <Button
                        shape="circle"
                        icon={<FormOutlined />}
                        onClick={handleDescriptionClick}
                    />
                    <Button
                        shape="circle"
                        icon={<UnorderedListOutlined />}
                        onClick={handleCharacteristicsClick}
                    />
                    <Button
                        shape="circle"
                        icon={<PercentageOutlined />}
                        onClick={handlePriceClick}
                    />
                    <Button
                        shape="circle"
                        color="danger"
                        icon={<DeleteOutlined />}
                        onClick={handleRemoveItem}
                    />
                </Styles.SectionContainer>
            }
        </Styles.BottomContainer>
    )

    return (
        <div>
            <Styles.ItemCard isEmbed={props.isEmbed} >
                <Styles.TopContainer>
                    <ItemData itemDetail={props.itemDetail} />
                    {renderActionsSection()}
                </Styles.TopContainer>
                {renderCollapsibleSection()}
            </Styles.ItemCard>
            <CharacteristicsModal
                open={modalCharOpen}
                onCancel={() => { setModalCharOpen(false) }}
                onAccept={() => { setModalCharOpen(false) }}
                okText='A'
                cancelText='B'
                itemDetail={props.itemDetail}
            />
            <PriceModal
                open={modalPriceOpen}
                onCancel={() => { setModalPriceOpen(false) }}
                onAccept={() => { setModalPriceOpen(false) }}
                okText='A'
                cancelText='B'
                itemDetail={props.itemDetail}
            />
            <DescriptionModal
                open={modalDescriptionOpen}
                onCancel={() => { setModalDescriptionOpen(false) }}
                onAccept={() => { setModalDescriptionOpen(false) }}
                okText='A'
                cancelText='B'
                itemDetail={props.itemDetail}
            />
        </div>
    )
}
